import { InfoMode as InfoModeValue } from '../../util/varibles/constants';

const INFO_MODES = [
    { label: 'PLAN INFO.', value: InfoModeValue.PLAN },
    { label: 'ACTUAL INFO.', value: InfoModeValue.ACTUAL },
];

interface InfoModeProps {
    value: InfoModeValue
    actualDisabled?: boolean
    onChange: (value: InfoModeValue) => void
}

export function InfoMode({ value, actualDisabled = false, onChange }: InfoModeProps) {
    return (
        <div className="inline-flex items-center gap-1" role="group" aria-label="Information mode">
            {INFO_MODES.map((mode) => {
                const isSelected = value === mode.value;
                const isDisabled = mode.value === InfoModeValue.ACTUAL && actualDisabled;

                return (
                    <button
                        key={mode.value}
                        type="button"
                        disabled={isDisabled}
                        className={`h-9 cursor-pointer whitespace-nowrap rounded-[40px] border-0 px-4 py-2.5 text-[12px] font-[600] leading-4 transition-colors duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--colorActive)] disabled:cursor-not-allowed disabled:opacity-40 ${isSelected
                            ? 'bg-[var(--colorActive)] text-white'
                            : 'bg-transparent text-[var(--colorMain)]'
                            }`}
                        aria-pressed={isSelected}
                        onClick={() => onChange(mode.value)}
                    >
                        {mode.label}
                    </button>
                );
            })}
        </div>
    );
}
